export default __webpack_public_path__ + "static/P_SearchThumb_IN-8015HD-16f57cea21a68ca3415b8913966eba5c.webp";